import React from 'react';
import { Plus } from 'lucide-react';
import { ChipRituel, THEMES_RAIL } from './RailAutomatismes';

/**
 * Le bandeau des fils conducteurs — layout MOBILE du rail (maquette validée
 * prof 2026-08-25) : sur colonne unique, les rails latéraux n'ont pas de
 * place ; les mêmes chips-séances s'affichent en bandeau au début de chaque
 * période, juste après le séparateur de vacances (émeraude pour les rituels
 * d'automatismes, rose pour les résolutions de problèmes). Même badge
 * « N att. », même panneau détail.
 */
const BandeauAutomatismes = ({ periode, rituels, onOpen, onAdd, onDelete, type = 'AUTOMATISME' }) => {
    const t = THEMES_RAIL[type] || THEMES_RAIL.AUTOMATISME;
    if (rituels.length === 0 && !onAdd) return null;
    return (
        <div
            className={`relative z-10 border-2 rounded-2xl px-4 py-3 shadow-md mb-8 ${t.bandeauBord}`}
            style={{ background: t.bandeauFond }}
        >
            <div className="flex items-center justify-between gap-2 mb-2.5">
                <div className="flex items-center gap-2">
                    <span className={`flex items-center justify-center w-7 h-7 rounded-lg text-white text-sm ${t.bandeauIcone}`}>{t.icone}</span>
                    <p className={`text-[13px] font-extrabold ${t.bandeauTitre}`}>{t.bandeauLabel} · Période {periode.numero}</p>
                </div>
            </div>
            <div className="flex flex-col gap-2">
                {rituels.map((r) => (
                    <ChipRituel key={r.id} rituel={r} onOpen={onOpen} onDelete={onDelete} type={type} />
                ))}
                {onAdd ? (
                    <button
                        onClick={onAdd}
                        className={`flex items-center justify-center gap-1.5 bg-white/60 border-2 border-dashed rounded-xl px-2.5 py-2 text-[11px] font-semibold transition-all ${t.ajoutClasse}`}
                    >
                        <Plus size={12} />
                        {t.ajoutTexte}
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default BandeauAutomatismes;
